import { getSintegradaServerApi } from "@/services/api";
import { OccupationPaginated } from "@/@types/sintegrada/OccupationPaginated";
import { InternalDepartmentParams } from "@/@types/sintegrada/InternalDepartmentParams";

type DepartmentHospitalizationsParams = InternalDepartmentParams & {
	department?: number;
};

export async function getDepartmentHospitalizations({
	uf,
	ibgeCode,
	...params
}: DepartmentHospitalizationsParams) {
	const url = `/1/Occupation/department-hospitalizations`;

	const { data } = await getSintegradaServerApi().get<OccupationPaginated>(url, {
		ibgeCode,
		...params,
	});

	return data || ({} as OccupationPaginated);
}
